export default "__VITE_ASSET__CHQsjDfM__"